/**
 * @param analytics
 * @param eventBtns
 * @module analyticsEvents
 */
module.exports = function( analytics, eventBtns ) {
    eventBtns.forEach( ( eventBtn ) => {
        eventBtn.addEventListener( 'click', function() {
            const category = this.getAttribute( 'data-ga-category' ),
                action = this.getAttribute( 'data-ga-action' ),
                label = this.getAttribute( 'data-ga-label' );

            if ( category && action && label ) {
                analytics.event(
                    {
                        eventCategory: category,
                        eventAction: action,
                        eventLabel: label,
                    }
                );
            }
        } );
    } );
}; // exports
